import { render, staticRenderFns } from "./year-picker.vue?vue&type=template&id=5e665458&scoped=true"
import script from "./year-picker.vue?vue&type=script&lang=js"
export * from "./year-picker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e665458",
  null
  
)

export default component.exports